import { Button } from '@/components/ui/button';
import { useLocale } from '@/lib/hooks/use-locale';
import { SparklesIcon } from 'lucide-react';
import React from 'react';

interface ImproveWritingButtonProps {
    improveWriting: () => Promise<void>;
}

export function ImproveWritingButton({ improveWriting }: ImproveWritingButtonProps) {
    const { t } = useLocale();

    const handleClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        await improveWriting();
    };

    return (
        <Button
            icon={SparklesIcon}
            variant="secondary-ai"
            onClick={handleClick}
            aria-label={t('rich_text_editor__improve_writing')}
        >
            {t('rich_text_editor__improve_writing')}
        </Button>
    );
}

export default ImproveWritingButton;
